var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c(
        "div",
        { ref: "slider", staticClass: "keen-slider", class: _vm.classes },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.slider && _vm.hasArrows
        ? [
            _c(
              "button",
              {
                class: {
                  "keen-slider__arrow": true,
                  "keen-slider__arrow--left": true,
                  "keen-slider__arrow--disabled": _vm.current === 0,
                },
                attrs: { "aria-label": "Previous" },
                on: {
                  click: function ($event) {
                    return _vm.slider.prev()
                  },
                },
              },
              [_c("span", { staticClass: "icon-circle-arrow-left" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                class: {
                  "keen-slider__arrow": true,
                  "keen-slider__arrow--right": true,
                  "keen-slider__arrow--disabled": _vm.current === 0,
                },
                attrs: { "aria-label": "Next" },
                on: {
                  click: function ($event) {
                    return _vm.slider.next()
                  },
                },
              },
              [_c("span", { staticClass: "icon-circle-arrow-right" })]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.slider && _vm.hasPagination
        ? _c(
            "div",
            { staticClass: "keen-slider__pagination" },
            _vm._l(_vm.dotHelper, function (_slide, idx) {
              return _c("button", {
                key: idx,
                staticClass: "rounded-full",
                class: { dot: true, "dot--active": _vm.current === idx },
                attrs: { "aria-label": "Go to slide " + (idx + 1) },
                on: {
                  click: function ($event) {
                    return _vm.slider.moveToIdx(idx)
                  },
                },
              })
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.slider && _vm.hasProgressBar
        ? _c(
            "div",
            {
              staticClass: "keen-slider__progress",
              attrs: {
                role: "progressbar",
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": Math.round(_vm.progressPercentage),
              },
            },
            [
              _c("span", {
                staticClass: "keen-slider__progress-fill",
                style: { width: _vm.progressPercentage + "%" },
              }),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }